export const TicketEntryStatusLabel = {
  [-2]: 'Expirado',
  [-1]: 'Cancelado',
  0: 'Borrador',
  1: 'Generado',
  2: 'Autorizado',
  3: 'Ingresado',
};
